import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';
import { findRecord } from '@warp-drive/utilities/json-api';
import type { Recipe } from '../../schemas/recipe.ts';

interface RecipeParams {
  recipe_id: string;
}

export default class ExploreRecipeRoute extends Route {
  @service declare store: Store;

  async model(params: Record<string, unknown>) {
    const { recipe_id } = params as unknown as RecipeParams;
    const recipeResult = await this.store.request<{ data: Recipe }>(
      findRecord('recipe', recipe_id)
    );
    const recipe = recipeResult.content.data;
    const source = recipe.contentSource ?? null;
    const creator = source?.creator ?? null;

    return {
      data: recipe,
      source,
      creator,
    };
  }
}
